module.exports = __webpack_public_path__ + "img/map-estate-mobile-img.39a16209.png";